import { createDebug } from '../../../../debug/src/utils/debug';

const debug = createDebug({ isEnabled: false });

/**
 * Safely parses a JSON string, returning the parsed object or null if parsing fails
 */
function safeJSONParse<T = unknown>(str: string): T | null {
  try {
    return JSON.parse(str);
  } catch {
    debug.error(`Error parsing JSON: ${str}`);
    return null;
  }
}

export { safeJSONParse };
